module.exports = __webpack_public_path__ + "static/media/MTL_ASC_SNP1.d748eb81.png";